import { useEffect } from "react"
import PortfolioForm from "~components/portfolio/PortfolioForm"
import { toast } from "react-toastify"
import { usePortfolioData } from "~hooks/usePortfolioData"
import useSecurities from "~hooks/useSecurities"

interface PortfolioContainerProps {
  userId: string
  userName?: string
  fetcherHook: any
  extractPortfolioData: (rawData: any) => any | null
}

const AggregatedPortfolioContainer = ({
  userId,
  userName,
  fetcherHook,
  extractPortfolioData,
}: PortfolioContainerProps) => {
  const { data: securitiesList = [] } = useSecurities()

  const {
    portfolio,
    brokerName: existingBrokerName,
    isLoading,
    existPortfolio,
    isError,
    refetch,
    rawPortfolios,
  } = usePortfolioData(
    fetcherHook,
    userId,
    extractPortfolioData,
    undefined,
    securitiesList,
  )

  useEffect(() => {
    if (userId) refetch()
  }, [userId])

  useEffect(() => {
    if (isError) toast.error("There was an error getting the user portfolio")
  }, [isError])

  if (isLoading) {
    return (
      <div style={{ marginTop: 20, textAlign: "center" }}>
        <p>Loading portfolio data...</p>
      </div>
    )
  }

  if (!rawPortfolios) {
    return (
      <div style={{ marginTop: 20, textAlign: "center" }}>
        <p>This user does not have portfolios</p>
      </div>
    )
  }

  return (
    <>
      <PortfolioForm
        userId={userId}
        userName={userName}
        brokerName={existingBrokerName}
        portfolio={portfolio}
        isLoading={isLoading}
        showSubmitBtn={false}
        showPooFields={false}
        existPortfolio={existPortfolio}
        disableFields={true}
        columns={3}
        hideEmpty={true}
        securities={securitiesList}
        showSecurityCode={false}
      />
    </>
  )
}

export default AggregatedPortfolioContainer
